import axios from "axios";
import { baseUrl } from "stores";
import {
  getMemberDeviceId,
  getMemberToken,
  MEMBER_APP_VERSION,
} from "./memberSession";

const memberAxios = axios.create({
  baseURL: baseUrl,
});

memberAxios.interceptors.request.use((config) => {
  const token = getMemberToken();
  if (token) {
    config.headers = {
      ...(config.headers || {}),
      token,
    };
  }
  return config;
});

export function getApiMessage(error, fallback = "Terjadi kesalahan") {
  if (!error.response) return "Sepertinya internetmu bermasalah";
  return error.response.data?.message || fallback;
}

export const memberApi = {
  login(data) {
    return memberAxios.post("webMember/login", {
      ...data,
      webDeviceId: getMemberDeviceId(),
      browser: window.navigator.userAgent,
      platform: window.navigator.platform,
    });
  },
  verifyBrowserOtp(data) {
    return memberAxios.post("webMember/verifyBrowserOtp", {
      ...data,
      webDeviceId: getMemberDeviceId(),
      browser: window.navigator.userAgent,
      platform: window.navigator.platform,
    });
  },
  requestResetDevice(email) {
    return memberAxios.post("mobileUser/requestResetDevice", { email });
  },
  cekNopeg(nopeg) {
    return memberAxios.post("mobileUser/cekNopeg", { nopeg });
  },
  cekEmail(data) {
    return memberAxios.post("mobileAuth/cekEmail", data);
  },
  requestOtp(email) {
    return memberAxios.post("webMember/requestPasswordOtp", { email });
  },
  cekOtp(data) {
    return memberAxios.post("mobileAuth/cekOtp", data);
  },
  completeRegister(data) {
    return memberAxios.post("mobileUser/updateAllData", {
      ...data,
      idDevice: "",
      fcmToken: "",
    });
  },
  resetPassword(data) {
    return memberAxios.post("mobileAuth/lupaPassword", data);
  },
  profile() {
    return memberAxios.get("mobileUser/profile");
  },
  updateFotoProfile(formData) {
    return memberAxios.post("mobileUser/updateFotoProfile", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  simpanan() {
    return memberAxios.get("mobileSimpanan/getSimpanan");
  },
  pengajuanSimpanan() {
    return memberAxios.get("mobileSimpanan/getListPengajuanSimpanan");
  },
  upgradeSimpanan(data) {
    return memberAxios.post("mobileSimpanan/upgradeSimpananBulanan", data);
  },
  pinjaman(params = {}) {
    return memberAxios.get("mobilePengajuan/getPengajuan", { params });
  },
  angsuran(idPengajuan) {
    return memberAxios.get("mobileAngsuran/getAngsuran", {
      params: { idPengajuan },
    });
  },
  submitPinjaman(data) {
    return memberAxios.post("mobilePengajuan/pengajuan", {
      ...data,
      tglPengajuan: Date.now(),
    });
  },
  submitTopup(data) {
    return memberAxios.post("mobilePengajuan/topup", {
      ...data,
      tglPengajuan: Date.now(),
    });
  },
  ajukanUlang(data) {
    return memberAxios.post("mobilePengajuan/ajukanUlang", {
      ...data,
      tglPengajuan: Date.now(),
    });
  },
  cancelPinjaman(data) {
    return memberAxios.post("mobilePengajuan/cancelPengajuan", data);
  },
  formPengajuan(idPengajuan) {
    return memberAxios.post("mobilePdf/formPengajuan", { idPengajuan });
  },
  formRegister() {
    return memberAxios.get("mobilePdf/formRegister");
  },
  notifikasi() {
    return memberAxios.get("mobileNotif/getNotif");
  },
  readNotifikasi(idNotif) {
    return memberAxios.patch("mobileNotif/updateNotif", { idNotif });
  },
  deleteNotifikasi(idNotif) {
    return memberAxios.patch("mobileNotif/deleteNotif", { idNotif });
  },
  deleteAllNotifikasi() {
    return memberAxios.patch("mobileNotif/deleteAllNotif");
  },
  cekPin(pin) {
    return memberAxios.post("mobileAuth/cekPin", { pin });
  },
  cekPasswordLupaPin(data) {
    return memberAxios.post("mobileAuth/cekPasswordLupaPin", data);
  },
  ubahPin(pin) {
    return memberAxios.post("mobileAuth/ubahPin", { pin });
  },
  ubahEmail(emailBaru) {
    return memberAxios.post("mobileAuth/ubahEmail", { emailBaru });
  },
  ubahPassword(data) {
    return memberAxios.post("mobileAuth/ubahPassword", data);
  },
  keluarKoperasi(data) {
    return memberAxios.post("mobileUser/pengajuanKeluarKoperasi", data);
  },
  statusKeluar() {
    return memberAxios.get("mobileUser/getStatusKeluar");
  },
  rekening() {
    return memberAxios.get("mobileRekening/getAllRekening");
  },
  pelunasan() {
    return memberAxios.get("mobilePelunasan/getListPelunasan");
  },
  submitPelunasan(formData) {
    formData.append("versi", MEMBER_APP_VERSION);
    return memberAxios.post("mobilePelunasan/ajukanPelunasan", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  chatMessages() {
    return memberAxios.get("webChat/member/messages");
  },
  chatSummary() {
    return memberAxios.get("webChat/member/summary");
  },
  sendChatMessage(message, attachment) {
    const formData = new FormData();
    formData.append("message", message || "");
    if (attachment) {
      formData.append("attachment", attachment);
    }
    return memberAxios.post("webChat/member/messages", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  terms() {
    return memberAxios.get("webMemberTerms");
  },
};
